import { AxiosResponse } from 'axios';
import { pipe } from 'ramda';
import { useQuery } from 'react-query';

import { PoolMaintenance } from '../types';

import { isNotNil } from 'utils/ramdaUtils';

import { getPoolById } from 'RestAPIs/poolMaintenance';

export const useGetPoolMaintenanceDetails = (rowId?: number | null) =>
  useQuery({
    queryKey: ['poolMaintenance', 'details', rowId],
    enabled: isNotNil(rowId),
    queryFn: async () =>
      await getPoolById(rowId).then(
        pipe<
          [AxiosResponse<PoolMaintenance>],
          PoolMaintenance,
          PoolMaintenance
        >(
          (value) => value.data,
          (v) => v
        )
      )
  });
